import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {delay} from '../utils/delay.js';

/**
 * scene2-lda-door
 */
export class Scene2LdaDoor extends Component {
    static TypeName = 'scene2-lda-door';
    /* Properties that are configurable in the editor */
    @property.object()
    wheelObj?: Object3D;

    rotateDoorStart = false;
    rotateWheelStart = false;

    start() {
        if (!this.wheelObj) {
            throw new Error(`scene2-lda-door(${this.object.name}): wheelObj is not set`);
        }
        this.rotateDoorStart = false;
        this.rotateWheelStart = false;
    }

    update(dt: number) {
        /* Wheel Rotation */
        if (this.rotateWheelStart) {
            this.wheelObj!.rotateAxisAngleDegObject([1, 0, 0], 70 * dt);
        }
        /* Door Rotation */
        if (this.rotateDoorStart) {
            this.object.parent!.rotateAxisAngleDegObject([0, 1, 0], -25 * dt);
        }
    }

    async startRot() {
        this.rotateWheelStart = true;
        await delay(1);
        this.rotateWheelStart = false;
        this.rotateDoorStart = true;
        await delay(1.5);
        this.rotateDoorStart = false;
    }
}
